export const ProductInfosPostLoader = () => {
    document.addEventListener("DOMContentLoaded", function () {
        // Das zu beobachtende Element
        const loadmoreButton = document.querySelector(".productTeaser__loadmore");

        // Überprüfe, ob das Element existiert, bevor der Observer gestartet wird
        if (loadmoreButton) {
            // Überprüft, ob das Element im Sichtfeld ist
            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // Entferne die Observer, um Mehrfachaufrufe zu verhindern
                        observer.disconnect();

                        // Füge die Klasse für den aktiven Zustand hinzu
                        loadmoreButton.classList.add("productTeaser__loadmore--active");

                        // Führe die Ajax-Anfrage durch
                        let offset = document.querySelectorAll(".productTeaser__list .product-card").length;
                        let url = "/ajax/load-more-product-cards?offset=" + offset;

                        // Hier kommt dein Ajax-Code, z.B. mit XMLHttpRequest oder fetch
                        // Beispiel mit fetch:
                        fetch(url)
                            .then(function (response) {
                                return response.text();
                            })
                            .then(function (data) {
                                // Überprüfe, ob die Antwort leer ist
                                if (data.trim() !== "") {
                                    // Füge die Antwort zur Produktliste hinzu
                                    document.querySelector(".productTeaser__list").insertAdjacentHTML("beforeend", data);
                                }

                                // Entferne die Klasse für den aktiven Zustand
                                loadmoreButton.classList.remove("productTeaser__loadmore--active");

                                // Wenn die Antwort nicht leer ist, reaktiviere den Observer, um auf weiteres Scrollen zu reagieren
                                if (data.trim() !== "") {
                                    observer.observe(loadmoreButton);
                                }
                            })
                            .catch(function (error) {
                                console.error("Fehler bei der Ajax-Anfrage:", error);
                            });
                    }
                });
            });

            // Starte den Observer und überwache das Loadmore-Element
            observer.observe(loadmoreButton);
        }
    });

}
